import PageCard from 'features/shared/components/card/PageCard';
import { Currency } from 'features/shared/enums/currency';
import FormGroup from 'features/shared/forms/components/FormGroup';
import InputGroup from 'features/shared/forms/components/inputGroup/InputGroup';
import { BindFieldFunction, FormErrors } from 'features/shared/forms/hooks/useForm';
import { useTranslationWithPrefix } from 'features/shared/hooks/useTranslationWithPrefix';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  bindField: BindFieldFunction;
  errors: FormErrors;
  currency: Currency;
}

const DepositsAmountSubForm = ({ bindField, errors, currency }: Props) => {
  //translations
  const tLabels = useTranslationWithPrefix("contracting\\contracting", "depositsAmountSubForm");
  const tCurrency = useTranslation("shared\\enums\\currency").t;

  // render
  return (
    <PageCard
      title={tLabels("cardTitle")}
      bodyClassName="pt-4 px-4"
      cardClassName="mb-4"
    >
      <div className="row no-gutters mx-n2">
        <div className="col-md-6 px-2">
          <FormGroup
            labelText={tLabels("depositsAmount.label")}
            inputId="depositsAmount"
            validationError={errors["depositsAmount"]}
          >
            <InputGroup
              placement="append"
              contentText={tCurrency(currency)}
            >
              <input
                id="depositsAmount"
                className="form-control"
                placeholder={tLabels("depositsAmount.placeholder")}
                {...bindField("depositsAmount", true)}
                type="number"
                min={0}
                step={100}
              />
            </InputGroup>
          </FormGroup>
        </div>
      </div>
    </PageCard>
  )
}

export default DepositsAmountSubForm;